import React, { useState } from 'react';
import classes from './UploadSalaryModal.module.css';
import api, { withCompanyId } from '../../Components/API/Api';
import Swal from 'sweetalert2';

function UploadSalaryModal({ isOpen, onClose }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleDownload = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      // const res = await api.get('/v1/download_direct_salary_template', {
      const res = await api.get('/v1/download_salary_allowance_template', {
        params: { token },
        responseType: 'blob',
      });

      const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'salary_template.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error', err);
      Swal.fire({
        icon: 'error',
        title: 'Download Failed',
        text: 'Failed to download template. Please try again.',
        confirmButtonColor: '#16A34A',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      Swal.fire({
        icon: 'warning',
        title: 'Action Required',
        text: 'Please choose a file to upload',
        confirmButtonColor: '#16A34A',
      });
      return;
    }

    try {
      setLoading(true);
      const fd = new FormData();
      fd.append('file', file, file.name);
      const payload = withCompanyId(fd);

      const res = await api.post('/v1/payroll/salary_structure/upload_direct_and_allowance', payload, {
      // const res = await api.post('/v1/payroll/salary_structure/upload_direct', payload, { 
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (res.status === 200 || res.status === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Upload Successful',
          text: res.data?.message || 'Salary data uploaded successfully!',
          confirmButtonColor: '#16A34A',
        });
        setFile(null);
        onClose();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: 'An error occurred during upload. Please try again.',
          confirmButtonColor: '#16A34A',
        });
      }
    } catch (err) {
      console.error('Upload error', err);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: err.response?.data?.message || 'Failed to upload file. Please try again.',
        confirmButtonColor: '#16A34A',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        <h3>Upload Basic Salary</h3>
        <p>Download the template, fill it, then upload the completed Excel file.</p>

        <div className={classes.actions}>
          <button
            onClick={handleDownload}
            disabled={loading}
            className={`${classes.btn} ${classes.btnPrimary}`}
          >
            Download Template
          </button>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            className={classes.fileInput}
          />
        </div>

        <div className={classes.buttonGroup}>
          <button
            onClick={onClose}
            className={`${classes.btn} ${classes.btnSecondary}`}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || !file}
            className={`${classes.btn} ${classes.btnPrimary}`}
          >
            {loading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UploadSalaryModal;
